module.exports = __webpack_public_path__ + "02baa5d77dae1626a4be7a0e7ffa83dd.png";